import { ordersBasketApiConnector } from 'apiConnector/orders-basket';
import type { EnrichFormRequest } from 'models/forms/EnrichFormRequest';
import type { StaticFormResult } from 'models/forms/StaticFormResult';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { ordersBasketFormUpdateFailed } from 'state/orders-basket/actions';
import { getOrdersBasketEnrichFormRequest } from 'state/orders-basket/selectors';
import { ordersBasketFormUpdatedThunk } from 'state/orders-basket/thunks';
import type { EpicWithThunk } from 'state/state.common';

export interface IOrdersBasketUpdateFormApi {
  updateForm(negotiationId: string, request: EnrichFormRequest): Observable<StaticFormResult>;
}

// TODO catch Error in Epic
export function ordersBasketFormUpdateRequestedEpic(): EpicWithThunk {
  return (actions$, state$, { oldHttpClient, frontLogger }) =>
    actions$.pipe(
      ofType('ORDERS_BASKET_FORM_UPDATE_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([action, state]) => {
        const request = getOrdersBasketEnrichFormRequest(state, action.formId);
        return request
          ? ordersBasketApiConnector(oldHttpClient)
              .updateForm(action.formId, request)
              .pipe(
                map(result => ordersBasketFormUpdatedThunk(action.formId, request.variationParameters, result)),
                catchError((error: Error) => {
                  frontLogger.error('An error occurred inside ordersBasketFormUpdateRequested {@FrontError}', error);
                  return of(ordersBasketFormUpdateFailed(action.formId));
                }),
              )
          : EMPTY;
      }),
    );
}
